/* Phantom advertorial — reading progress bar + sticky mobile CTA reveal. */
(function () {
  function init() {
    // Reading progress bar
    var fill = document.querySelector('.adv-progress__fill');
    if (fill) {
      var onScroll = function () {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        var pct = Math.min(100, Math.max(0, (h.scrollTop || document.body.scrollTop) / max * 100));
        fill.style.width = pct + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    // Sticky mobile CTA — reveal once the hero scrolls out of view
    var sticky = document.querySelector('[data-adv-sticky-cta]');
    var hero = document.querySelector('[data-adv-hero]');
    if (sticky) {
      if (hero && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { sticky.classList.remove('is-visible'); }
            else { sticky.classList.add('is-visible'); }
          });
        }, { rootMargin: '-120px 0px 0px 0px' });
        io.observe(hero);
      } else {
        var showAt = function () {
          if ((window.scrollY || document.documentElement.scrollTop) > 600) sticky.classList.add('is-visible');
          else sticky.classList.remove('is-visible');
        };
        window.addEventListener('scroll', showAt, { passive: true });
        showAt();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
